// Default polling interval is 15sec
export const pollingInterval = 15_000 as const

// Slow polling interval: 15min
export const slowPollingInterval = 15 * 60_000
